import { render, staticRenderFns } from "./BDRDictionary.vue?vue&type=template&id=7b8fa33a&"
import script from "./BDRDictionary.vue?vue&type=script&lang=js&"
export * from "./BDRDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports